export default {

    data () {
        return {
            showPageHeader: false
        }
    },

    created () {
        window.addEventListener('scroll', this.handleScroll)
    },

    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    },

    methods: {
        handleScroll (event) {
            const scrollTop = event.target.scrollingElement.scrollTop
            if (scrollTop > 30) {
                this.showPageHeader = true
            } else {
                this.showPageHeader = false
            }
        }
    }

}
